import React, { Component } from "react";
import firebase from "../firebase/db";
import axios from "axios";

class SendEmail extends Component {
  state = {
    options: "Select",
    email: "",
    subject: "",
    body: ""
  };

  handleSend = async e => {
    e.preventDefault();

    if (this.state.options === "ALL") {
      let userEmails = [];

      this.props.users.map(u => {
        userEmails.push(u.email);
      });

      const body = {
        email: userEmails,
        subject: this.state.subject,
        body: this.state.body
      };

      console.log(body.email);

      axios
        .post(
          "https://us-central1-juaab-588e2.cloudfunctions.net/api/sendMail",
          body
        )
        .then(res => {
          if (res.data === "Massege Sent") {
            alert("Massege Sent");
          }
        })
        .catch(err => alert(err));
    } else {
      const body = {
        email: this.state.email,
        subject: this.state.subject,
        body: this.state.body
      };

      axios
        .post(
          "https://us-central1-juaab-588e2.cloudfunctions.net/api/sendMail",
          body
        )
        .then(res => {
          if (res.data === "Massege Sent") {
            alert("Massege Sent");
          }
        })
        .catch(err => alert(err));
    }
  };
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    return (
      <form className="container">
        <div className="form-group">
          <p style={{ textAlign: "center" }}>Select Email Option </p>
          <div style={{ display: "flex" }}>
            <select
              name="options"
              className="form-control"
              id="options"
              style={{ marginLeft: "75px" }}
              onChange={this.handleChange}
            >
              <option
                className="form-control"
                required="required"
                value="Select"
              >
                {" "}
                Select
              </option>
              <option className="form-control" required="required" value="ALL">
                ALL
              </option>
              <option
                className="form-control"
                required="required"
                value="One By One"
              >
                One By One
              </option>
            </select>
          </div>
        </div>
        <div className="form-group">
          <div style={{ display: "flex" }}>
            <label>To: </label>{" "}
            <input
              type="email"
              name="email"
              className="form-control"
              style={{ marginLeft: "55px" }}
              onChange={this.handleChange}
            ></input>
          </div>
        </div>

        <div className="form-group">
          <div style={{ display: "flex" }}>
            <label>Subject: </label>{" "}
            <input
              type="text"
              name="subject"
              className="form-control"
              style={{ marginLeft: "20px" }}
              onChange={this.handleChange}
              required="required"
            ></input>
          </div>
        </div>
        <div className="form-group">
          <div style={{ display: "flex" }}>
            <label>Body: </label>{" "}
            <textarea
              type="text"
              name="body"
              className="form-control"
              style={{ marginLeft: "35px" }}
              rows="5"
              onChange={this.handleChange}
              required="required"
            ></textarea>
          </div>
        </div>
        <button
          className="btn btn-primary"
          style={{ marginTop: "10px", marginBottom: "10px" }}
          onClick={this.handleSend}
          onChange={this.handleChange}
        >
          Send
        </button>
      </form>
    );
  }
}

export default SendEmail;
